<template>
  <div class="home">
    <mynav1_en :data='nvdata'></mynav1_en>
    
    <div id="spchead">
      <div>SUPPORT</div>
      <div>SZZT Payment Support Center (NPSC) is dedicated to providing our customers with quality services and support. Our customers have access to a team of specialists with extensive product knowledge and deep understanding of best practices in the field.</div>
    </div>
    <div id="spcsp">
      <div class="spctt">Support</div>
      <h5 v-for="item in sps" :key="item.label">
        <img :src="require('@/assets/pic/supportcent/'+item.pic)" />
        <div>{{item.label}}</div>
        <label>{{item.desc}}</label>
      </h5>
    </div>
    <div id="spcdk">
      <div class="spctt">Development Kit</div>
      <h5 v-for="item,index in dks" :key="index+'dkkey'">
        <img :src="require('@/assets/pic/supportcent/dk.png')" />
        <div v-for="item1 in item" :key="item1"><label></label>{{item1}}</div>
      </h5>
    </div>
    <div id="spcmc">
      <div class="spctt">Multi-modal product customization</div>
      <div class="spcmcfr">
        <img :src="require('@/assets/pic/supportcent/mc1.jpg')" />
        <div>
          <div>CBU</div>
          <label>The whole machine is directly exported to the country where the customer is located, without any processing or assembly.</label>
        </div>
      </div>
      <div class="spcmcfr">
        <div>
          <div>SKD</div>
          <label>Shipped as a semi-finished product, assembled by the customer at the factory in the country where they are located. This method is suitable for some countries where the import tariff of SKD is lower than that of CBU</label>
        </div>
        <img :src="require('@/assets/pic/supportcent/mc2.jpg')" />
      </div>
      <div class="spcmcfr">
        <img :src="require('@/assets/pic/supportcent/mc3.jpg')" />
        <div>
          <div>CKD</div>
          <label>It is shipped in the form of all parts, and the customer's own patch and assembly in the factory in the country.</label>
        </div>
      </div>
    </div>
    <div id="spcas">
      <div class="spctt">After-sales Services</div>
      <div id="spcasfr">
        <img :src="require('@/assets/pic/supportcent/as.jpg')" />
        <div>
          <label class="asnumber">1</label>
          <label>Repair facility authorizationand management</label>
        </div>
        <div>
          <h5>
            <label class="asnumber">2</label>
            <label>Spare parts supply</label>
          </h5>
          <h5>
            <label class="asnumber">4</label>
            <label>Customer complain disposition</label>
          </h5>
        </div>
        <div>
          <h5>
            <label class="asnumber">3</label>
            <label>Repair training and support</label>
          </h5>
          <h5>
            <label class="asnumber">5</label>
            <label>Repair service</label>
          </h5>
        </div>
      </div>
      <div id="spcrq">
        <div class="spctt">Fill in requirements</div>
        <el-row class="spcrqpd">
          <el-col  :span="12">
            <el-input v-model="pform.name" placeholder="Name">
              <template slot="prefix">
                <div class="spredstar">*</div>
              </template>
            </el-input>
          </el-col>
          <el-col  :span="12">
            <el-input v-model="pform.email" placeholder="E-mail">
              <template slot="prefix">
                <div class="spredstar">*</div>
              </template>
            </el-input>
          </el-col>
        </el-row>
        <el-row class="spcrqpd">
          <el-col :span="12">
            <el-input v-model="pform.tel" placeholder="Tel">
              <template slot="prefix">
                <div class="spredstar">*</div>
              </template>
            </el-input>
          </el-col>
          <el-col :span="12">
            <el-input v-model="pform.theme" placeholder="Theme">
              <template slot="prefix">
                <div class="spredstar">*</div>
              </template>
            </el-input>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-input
              type="textarea"
              :rows="5"
              placeholder="* What can we do for you?"
              v-model="pform.content">
              <template slot="prefix">
                <div class="spredstar">*</div>
              </template>
            </el-input>
          </el-col>
        </el-row>
        <h5 @click="sendEmail">Submit</h5>
      </div>
    </div>
    <myfooter_en :data='ftdata' ></myfooter_en>
  </div>
</template>
<style>
  #spchead {
    margin-top: .02rem;
    height: 3.64rem;
    background-image: url('../assets/pic/head6.jpg');
    background-size: 100% 100%;
    padding-left: 4.26rem;
    overflow: hidden;
  }
  #spchead div:nth-child(1) {
    font-size: .48rem;
    font-weight: 800;
    color: #303030;
    margin-top: 1.1rem;
  }
  #spchead div:nth-child(2) {
    width: 7.28rem;
    font-size: .2rem;
    font-weight: 400;
    color: #3B3B3B;
    line-height: .3rem;
    margin-top: .04rem;
  }
  .spredstar {
    color:  red;
    font-size: .2rem;
    height: .9rem;
    line-height: .9rem;
    margin-left: .17rem;
  }
  .spctt {
    font-size: .6rem;
    font-weight: bold;
    color: #333333;
  }
  #spcsp {
    height: 6.14rem;
    background: white;
    text-align: center;
    padding-top: .71rem;
  }
  #spcsp h5 {
    margin: .6rem .3rem 0 .3rem;
    background: #F8F8F8;
    width: 4.39rem;
    height: 2.88rem;
    display: inline-block;
    vertical-align: middle;
  }
  #spcsp img {
    width: .84rem;
    height: .84rem;
    margin-top: .25rem;
  }
  #spcsp h5 div {
    font-size: .22rem;
    font-weight: bold;
    color: #333333;
    margin-top: .1rem;
  }
  #spcsp h5 label {
    font-size: .14rem;
    font-weight: bold;
    color: #666666;
    display: block;
    margin: .11rem .12rem 0 .12rem;
  }
  #spcdk {
    height: 8.2rem;
    background: rgb(235, 245, 251);
    padding-top: .66rem;
    text-align: center;
  }
  #spcdk h5 {
    display: inline-block;
    width: 3.96rem;
    height: 4.4rem;
    margin: .77rem .11rem 0 .11rem;
    background: white;
    border-radius: .04rem;
    vertical-align: top;
    padding-left: .29rem;
  }
  #spcdk img {
    width: .7rem;
    height: .7rem;
    margin: .37rem 0 .37rem 0;
  }
  #spcdk h5 div {
    text-align: left;
    font-size: .2rem;
    font-weight: bold;
    color: #666666;
    margin-bottom: .28rem;
  }
  #spcdk h5 label {
    display: inline-block;
    width: .16rem;
    height: .16rem;
    background: #0080CC;
    margin-right: .12rem;
    border-radius: .16rem;
  }

  #spcmc {
    background: white;
    text-align: center;
    padding-top: 1.18rem;
    overflow: hidden;
  }
  #spcmc .spctt {
    margin-bottom: .71rem;
  }
  .spcmcfr {
    width: 12.32rem;
    height: 5.6rem;
    margin: 0 auto .63rem auto;
    background: #F5F5F5;
  }
  .spcmcfr img {
    width:50%;
    height: 100%;
    margin: 0;
  }
  .spcmcfr div {
    width: 50%;
    display: inline-block;
    vertical-align: top;
    text-align: left;
    font-size: .60rem;
    font-weight: 400;
    color: #4D4D4D;
    box-sizing: border-box;
    padding-left: .42rem;
  }
  .spcmcfr div div {
    padding-left: 0 !important;
    margin: 1.08rem 0 .25rem 0;
  }
  .spcmcfr label {
    display: block;
    font-size: .22rem;
    font-weight: 400;
    color: #666666;
    line-height: .48rem;
    padding-right: .4rem;
  }
  #spcas {
    background: white;
    padding-top: .72rem;
    text-align: center;
  }
  #spcasfr {
    margin-top: .96rem;
    height: 3.88rem;
  }
  #spcasfr img {
    width: 4.62rem;
    height: 3.88rem;
  }
  #spcasfr div {
    display: inline-block;
    vertical-align: top;
    height: calc(100% - .04rem);
  }
  #spcasfr div:nth-child(2) {
    box-sizing: border-box;
    padding-top: 1.24rem;
    color: red;
    width: 2.59rem;
    border-right: .02rem solid #E6E6E6;
    border-top: .02rem solid #E6E6E6;
    border-bottom: .02rem solid #E6E6E6;
    text-align: center;
  }
  .asnumber {
    display: block;
    width: .5rem;
    height: .5rem;
    border-radius: .5rem;
    background: #0080CC;
    line-height: .5rem;
    font-size: .36rem;
    font-weight: bold;
    color: #FFFFFF;
    margin: 0 auto .1rem auto;
  }
  #spcasfr div:nth-child(2) label:nth-child(2) {
    display: block;
    margin-top: .1rem;
    font-size: .2rem;
    font-weight: bold;
    color: #333333;
  }
  #spcasfr div:nth-child(3),  #spcasfr div:nth-child(4){
    width: 2.53rem;
    border-top: .02rem solid #E6E6E6;
    border-bottom: .02rem solid #E6E6E6;
    height: 3.8rem;
  }
  #spcasfr div:nth-child(3) h5, #spcasfr div:nth-child(4) h5 {
    margin: 0;
    height: 50%;
  }
  #spcasfr div:nth-child(3) label, #spcasfr div:nth-child(4) label {
    display: block;
  }
  #spcasfr div:nth-child(3) h5:nth-child(2), #spcasfr div:nth-child(4) h5:nth-child(2) {
    height: calc(50% - .02rem);
    border-top: .02rem solid #E6E6E6;
  }

  #spcasfr div:nth-child(3) h5, #spcasfr div:nth-child(4) h5 {
    padding-top: .46rem;
    box-sizing: border-box;
  }
  #spcasfr div:nth-child(4) {
    width: 2.76rem;
    border-left: .02rem solid #E6E6E6;
  }
  #spcasfr div:nth-child(3) label:nth-child(2), #spcasfr div:nth-child(4) label:nth-child(2) {
    width: 1.8rem;
    margin: 0 auto;
  }
  #spcrq {
    padding-top: 1.02rem;
  }
  #spcrq .el-row {
    width: 12.28rem;
    margin: 0 auto;
  }
  #spcrq .el-row:nth-child(2) {
    margin-top: .68rem;
  }
  #spcrq .el-row:nth-child(3), #spcrq .el-row:nth-child(4){
    margin-top: .32rem;
  }
  .spcrqpd .el-col:nth-child(1) {
    padding-right: .23rem;
  }
  .spcrqpd .el-col:nth-child(2) {
    padding-left: .23rem;
  }
  #spcrq h5 {
    width: 2.57rem;
    height: .94rem;
    background: #0080CB;
    border-radius: 10px;
    margin: .74rem auto 1.48rem auto;
    line-height: .94rem;
    font-size: .33rem;
    font-weight: bold;
    color: #FFFFFF;
    cursor: pointer;
  }
  #spcrq .el-input__inner {
    border: none;
    background: #F2F3F4;
    height: .917rem;
    font-size: .24rem;
  }
  #spcrq .el-textarea__inner {
    border: none;
    background: #F2F3F4;
    font-size: .24rem;
  }

 

</style>
<script>
// @ is an alias to /src
import {cmdata} from '@/assets/data/data'
require('@/assets/zt.css')
import mynav1_en from '@/components/mynav1_en'
import myfooter_en from '@/components/footer_en'
import axios from 'axios'
import md5 from 'js-md5'


export default {
  components: {
    mynav1_en,myfooter_en
  },
  data () {
    return {
      pform: {
        name: '',
        email: '',
        tel: '',
        theme: '',
        content: ''
      },
      dks: [
        ['Equipment management module', 'Printer module','Magnetic stripe cards','Contact card','ID card identification'],
        ['Password keyboard','Contactless card','EMV kernel','Serial port','LED'],
        ['Network management','Camera scan code','System Management','Barcode']
      ],
      sps: [
        {
          pic: 'sp1.png',
          label: 'Training',
          desc: 'SZZT offers a variety of technical training including software development andhardware maintenance to our international partners to ensure they know our products as well as we do.'
        },
        {
          pic: 'sp2.png',
          label: 'Technical Support',
          desc: 'Application development  On-site technical supportRemote technical support Consultancy services RFP preparation support'
        },
        {
          pic: 'sp3.png',
          label: 'Warranty',
          desc: 'SZZT offers a standard 1-year warranty on all products and extended warranty rates if required.'
        }
      ],
      ovscroll: false,
      mdctdata: '',
      pdctdata: '',
      headdata: '',
      menudata: '',
      scrdist: 0,
      ftdata: {
        type: 'supportcent',
        lcallback: (stype) => {
          this.setHead(stype)
        }
      },
      nvdata: {
        sindex: 4,
        type: 'supportcent',
        lcallback: (stype) => {
          if (stype) {
            this.setHead(stype)
          }
        }
      }
   
    }
  },
  computed: {
    lang () {
      return localStorage.lang
    }
  },
  methods: {
    sendEmail () {
      if (!/^(\w)+(\.\w+)*@(\w)+((\.\w+)+)$/.test(this.pform.email)) {

        this.$notify({
          title: '',
          message: 'E-mail format is not correct',
          type: 'warning'
        })
        return
      }
      if (!this.pform.name||!this.pform.tel||!this.pform.theme||!this.pform.content) {

        this.$notify({
          title: '',
          message: 'Please enter complete',
          type: 'warning'
        })
        return
      }
      var name = this.pform.name
      var tel = this.pform.tel
      var content = this.pform.content
      var useremail = this.pform.email
      var timestamp=new Date().getTime()
      var param = {
        userEmail: 'marketing@szzt.com.cn',
        subject: this.pform.theme,
        htmlMsg: `<b>Name:</b><br/>${name}<br/><br/>
<b>Tel:</b><br/>${tel}<br/><br/><b>E-mail:</b><br/>${useremail}<br/><br/><b>Content:</b><br/>${content}<br/>`
      }
      axios.get('https://proxy.szzt.com.cn/pushEmail', { headers: {timestamp:timestamp, sign:md5('szzt@eamil'+timestamp)}, params: param }).then(res => {
        if (res.data.status==200) {
          this.$notify({
            title: '',
            type: 'success',
            message: 'Thank you, we will get back to you as soon as possible.',
            duration: 0
          });
          this.pform = {
            name: '',
            email: '',
            tel: '',
            theme: '',
            content: ''
          }
        } else {
          this.$notify({
            title: '',
            message: res.data.data,
            type: 'warning'
          })
        }
      }).then('')
    },
    backToTop () {
      window.scrollTo(0,0)
    },
    onPageScroll (dist) {
      this.ovscroll = dist>93?true:false
      if (dist - this.scrdist > 93) {
        this.scrdist = dist
      } else if (dist < this.scrdist) {
        this.scrdist = dist
      }
      if (dist>0) this.ismenu=false
    },
    setRem() {
        var html = document.querySelector('html');
        var width = html.getBoundingClientRect().width;
        html.style.fontSize = width/20 + 'px'; /// 20
    },
    initWindowEv () {
      /// rem=px/2/14
      window.addEventListener('orientationchange', this.setRem);
      window.addEventListener('resize', this.setRem);
      this.setRem()

      var _this = this
      // var index = 1
      window.onscroll = function (e) {
        var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
        _this.onPageScroll(scrollTop)
      }
    },
    setHead (type) {
      return
      var item = cmdata['supportcent']
      this.headdata = {
        title: item.title,
        desc: item.desc,
        pic: item.pic,
        wtype: 0,
        type: type,
        category: item.category,
        callback: (ctype) => {
          this.pdctdata = {
            type: ctype,
          }

          this.$router.replace({path:'/supportcent',query:{}})
        }
      }
    },
    init () {
      // var stype = this.$route.query.stype?this.$route.query.stype:'flexible'
      this.setHead('supportcent')
    }
  },
  mounted () {
    this.initWindowEv()
    this.init()

  }
}
</script>
